export default "__VITE_ASSET__CIqMW8JY__"